//https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=9402

let iconList = {
  success: `<svg t="1676614776435" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8374" width="200" height="200"><path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8c12.7 17.7 39 17.7 51.7 0l210.6-292c3.9-5.3 0.1-12.7-6.4-12.7z" p-id="8375"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" p-id="8376"></path></svg>`,
  warring: `<svg t="1676624120954" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8374" width="200" height="200"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" p-id="8375"></path><path d="M512 336m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" p-id="8376"></path><path d="M536 448h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" p-id="8377"></path></svg>`,
  close:`<svg t="1676876379677" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8374" width="200" height="200"><path d="M685.4 354.8c0-4.4-3.6-8-8-8l-66 0.3L512 465.6l-99.3-118.4-66.1-0.3c-4.4 0-8 3.5-8 8 0 1.9 0.7 3.7 1.9 5.2l130.1 155L340.5 670c-1.2 1.5-1.9 3.3-1.9 5.2 0 4.4 3.6 8 8 8l66.1-0.3L512 564.4l99.3 118.4 66 0.3c4.4 0 8-3.5 8-8 0-1.9-0.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" p-id="8375"></path><path d="M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" p-id="8376"></path></svg>`
}

export default class XyIcon extends HTMLElement {

  static get observedAttributes() { return ['name','size','color','path'] }

  constructor() {
      super();
      const shadowRoot = this.attachShadow({ mode: 'open' });
      shadowRoot.innerHTML = `
      <style>
      :host{
          font-size:inherit;
          display:inline-block;
          transition:.3s;
      }
      .icon {
          display:block;
          width: 1em;
          height: 1em;
          margin: auto;
          fill: currentColor;
          overflow: hidden;
          /*transition:inherit;*/
      }
      :host([spin]){
          animation: rotate 1.4s linear infinite;
      }
      @keyframes rotate{
          to{
              transform: rotate(360deg); 
          }
      }
      </style>
      <div class="svg-box 123123 444" >
        
      </div>
      `
  }

  get view() {
      return this.getAttribute('view')||1024;
  }

  get name() {
      return this.getAttribute('name');
  }

  get path() {
      return this.getAttribute('path')||'';
  }

  set name(value) {
      this.setAttribute('name', value);
  }

  set path(value) {
      this.setAttribute('path', value);
  }

  get size() {
    // console.log('11111111111')
      return this.getAttribute('size')||'';
  }

  get color() {
      return this.getAttribute('color')||'';
  }

  set size(value) {
    // //debugger
      this.setAttribute('size', value);
  }

  set color(value) {
      this.setAttribute('color', value);
  }

  
  connectedCallback() {
      this.icon = this.shadowRoot.querySelector('svg');
      this.use = this.shadowRoot.querySelector('.svg-box');
      this.d = this.shadowRoot.querySelector('.svg-box');
      this.size && (this.size = this.size);
      this.color && (this.color = this.color);
      this.name && (this.name = this.name); 
      this.path && (this.path = this.path);
  }

  attributeChangedCallback (name, oldValue, newValue) {
        // //debugger
      if( name == 'name' ){
        
        // this.d.setAttribute("d", newValue);
        let icon = iconList[newValue]
        this.d.innerHTML = icon;
          // this.use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', `../iconfont/icon.svg#icon-${newValue}`);
      }
      if( name == 'path' && this.d){
        
          this.d.innerHTML = iconList[newValue];
      }
      if( name == 'color' ){ 
        // //debugger
        this.d.querySelector('svg').style.color = newValue;
      }
      if( name == 'size'){
        //   this.icon.style.fontSize = newValue + 'px';
        this.d.querySelector('svg').style.width = newValue + 'px';
        this.d.querySelector('svg').style.height = newValue + 'px';
      }
  }
}

if(!customElements.get('xy-icon')){
  customElements.define('xy-icon', XyIcon);
}